import { inject, Injectable } from '@angular/core';
import {
  FileRecordCategoryEnum,
  FileSensitivityEnum,
} from '@splitsecondconnect/ultramarine-shared';
import {
  SscFileItem,
  SscFileUploadAdapter,
} from '@marineform/ssc-ui';
import { from, map, Observable, switchMap } from 'rxjs';
import { v4 as uuidv4 } from 'uuid';

import { FileCompressionService } from './file-compression.service';
import { FileStorageService } from './file-storage.service';

@Injectable({
  providedIn: 'root',
})
export class ManageFileUploadAdapter implements SscFileUploadAdapter {
  readonly #compression = inject(FileCompressionService);
  readonly #storage = inject(FileStorageService);

  readonly storageUrl = this.#storage.storageUrl;

  upload(file: File): Observable<SscFileItem> {
    const uuid = uuidv4();
    return from(this.#compression.compressFiles([file])).pipe(
      switchMap(([compressed]) =>
        this.#storage.uploadFile(uuid, compressed).pipe(
          map(
            (): SscFileItem => ({
              uuid,
              name: compressed.name,
              size: compressed.size,
              mimeType: compressed.type,
              sensitivity: FileSensitivityEnum.PUBLIC,
              recordCategory: FileRecordCategoryEnum.IMAGE,
              isFavorite: false,
            }),
          ),
        ),
      ),
    );
  }
}
